var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { width: "100%", height: "100vh", display: "flex" },
    },
    [
      _c("iframe", {
        staticStyle: { flex: "1" },
        attrs: { src: _vm.iframeUrl, frameborder: "0" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }